
import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog, DialogContent, DialogTitle,
    IconButton,
    Tooltip,
    Typography
} from '@mui/material';

import SyntaxHighlighter from 'react-syntax-highlighter';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useContext, useState } from 'react';
import { ResearchContext } from '../../ResearchContext';

export const XMLDialog = ({ isOpen, handleClose }) => {

    const [tooltipMessage, setTooltipMessage] = useState("Copia");

    const {
        state,
        isLoadingUfficiTerritorioXML,
        isLoadingUfficiDistrettoXML,
        isLoadingComuneUfficiXML,
        isLoadingComuneAltriUfficiXML,
    } = useContext(ResearchContext)

    const {
        ufficiXML,
        altriUfficiXML,
    } = state;

    return (<Dialog open={isOpen} fullWidth>
        <IconButton
            aria-label="close"
            size="small"
            sx={{
                position: "absolute",
                top: 8,
                right: 4,
            }}
            onClick={handleClose}>
            <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
            RISULTATO IN XML
        </DialogTitle>
        <DialogContent>
            <Typography>
                Uffici
                <Tooltip title={tooltipMessage} onClose={() => {
                    setTooltipMessage("Copia");
                }}>
                    <IconButton
                        onClick={() => {
                            navigator.clipboard.writeText(ufficiXML);
                            setTooltipMessage("Copiato nella clipboard!");
                        }}>
                        <ContentCopyIcon />
                    </IconButton>
                </Tooltip>
            </Typography>
            <SyntaxHighlighter language="xml">
                {
                    ufficiXML
                }
            </SyntaxHighlighter>
            {
                altriUfficiXML &&
                <div>
                    <Typography>
                        Altri uffici
                        <Tooltip title={tooltipMessage} onClose={() => {
                            setTooltipMessage("Copia");

                        }}>
                            <IconButton
                                onClick={() => {
                                    navigator.clipboard.writeText(altriUfficiXML);
                                    setTooltipMessage("Copiato nella clipboard!");
                                }}>
                                <ContentCopyIcon />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                    <SyntaxHighlighter language="xml">
                        {
                            altriUfficiXML
                        }
                    </SyntaxHighlighter>
                </div>
            }

        </DialogContent>

    </Dialog>)
}